exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.profile-img[data-v-5b9e9cee] {\n\toverflow: hidden;\n}\n", ""]);

// exports
